import { Component, computed, Directive, effect, inject, input } from '@angular/core';
import { halfWindow, WindowStore } from './window.store';


@Component({
    selector: 'ui-window',
    styles: [
        `
        .window {
            z-index: 501;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            flex-direction: column;
        }

        .half-window {
            width: 50%;
        }

        @media(max-width: 900px) {
            .half-window {
                width: 100%;
            }
            ::ng-deep .toggle-half-window {
                display: none;
            }
        }
        `,
    ],
    template: `
        <div class="window fit-to-relative shadow d-flex flex-column" [class.half-window]="halfWindow()" animate.enter="slide-left-enter" animate.leave="slide-left-leave">
            <ng-content></ng-content>
        </div>
    `,
})
export class WindowComponent {

    name = input.required<string>();

    private store = inject(WindowStore);

    halfWindow = computed(() => halfWindow(this.store.halfWindows(), this.name()));

    ngOnInit() {
        this.store.openWindow(this.name());
    }

    ngOnDestroy() {
        this.store.closeWindow();
    }
}


@Directive({
    selector: 'ui-window[halfWindow]'
})
export class WindowDirective {

    halfWindow = input(false);

    private store = inject(WindowStore);

    constructor() {
        effect(() => {
            this.store.expandWindow(!this.halfWindow());
        });
    }
}
